const SUPPORT_EMAIL_ADDRESS = "support@cyara.com";

export { SUPPORT_EMAIL_ADDRESS }